import { render } from "./Menu.vue?vue&type=template&id=30b384a0"
import script from "./Menu.vue?vue&type=script&lang=js"
export * from "./Menu.vue?vue&type=script&lang=js"

import "./Menu.vue?vue&type=style&index=0&id=30b384a0&lang=scss"
script.render = render

export default script